import { render, staticRenderFns } from "./job.vue?vue&type=template&id=c5350524&scoped=true&"
import script from "./job.vue?vue&type=script&lang=js&"
export * from "./job.vue?vue&type=script&lang=js&"
import style0 from "./job.vue?vue&type=style&index=0&id=c5350524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5350524",
  null
  
)

export default component.exports